import * as Yup from 'yup';

import {
    BusinessCategory,
    BusinessDefaultProduct,
    BusinessProductPriceTier,
    BusinessServingContainer,
} from '@barboxx/models/types';
import { atOneOrTheOther, transformEmptyToNull } from '@barboxx/utils';

export const BUSINESS_PRODUCT_PRICE_TIER_SCHEMA =
    Yup.object<BusinessProductPriceTier.Base>().shape({
        id: Yup.number().required(),
        productId: Yup.number().required(),
        priceTierId: Yup.number().required(),
        businessId: Yup.number().required(),
        isDefault: Yup.boolean().default(false),
        isActive: Yup.boolean().default(true),
        displayOrder: Yup.number().nullable().default(null),
        pourTypeId: Yup.number().nullable().default(null),
        priceAdjustment: Yup.number()
            .nullable()
            .default(null)
            .when('pourTypeId', {
                is: (pourTypeId: number | null) => pourTypeId !== null,
                then: schema =>
                    schema.required(
                        'Price adjustment is required when pour type is set.'
                    ),
                otherwise: schema => schema.nullable(),
            }),
    });
export const CREATE_BUSINESS_PRODUCT_PRICE_TIER_SCHEMA =
    BUSINESS_PRODUCT_PRICE_TIER_SCHEMA.omit(['id']);

export const BUSINESS_CATEGORY_SCHEMA =
    Yup.object<BusinessCategory.Base>().shape({
        id: Yup.number().required(),
        categoryId: Yup.number().required(),
        businessId: Yup.number().required(),
        featuredCategory: Yup.boolean().default(false),
        isActive: Yup.boolean().default(true),
        displayOrder: Yup.number().nullable().default(null),
        displayName: Yup.string()
            .nullable()
            .default(null)
            .transform(transformEmptyToNull),
    });
export const CREATE_BUSINESS_CATEGORY_SCHEMA = BUSINESS_CATEGORY_SCHEMA.omit([
    'id',
]);

export const BUSINESS_DEFAULT_PRODUCT_SCHEMA =
    Yup.object<BusinessDefaultProduct.Base>()
        .shape({
            id: Yup.number().required(),
            businessId: Yup.number().required(),
            productId: Yup.number().required(),
            productTypeId: Yup.number().nullable().default(null),
            productSubtypeId: Yup.number().nullable().default(null),
            isActive: Yup.boolean().default(true),
            notes: Yup.string().nullable().default(null),
        })
        .test(atOneOrTheOther('productTypeId', 'productSubtypeId'));
export const CREATE_BUSINESS_DEFAULT_PRODUCT_SCHEMA =
    BUSINESS_DEFAULT_PRODUCT_SCHEMA.omit(['id']);

export const BUSINESS_SERVING_CONTAINER_SCHEMA =
    Yup.object<BusinessServingContainer.Base>().shape({
        id: Yup.number().required(),
        servingContainerId: Yup.number().required(),
        businessId: Yup.number().required(),
        isActive: Yup.boolean().default(true),
        displayOrder: Yup.number().nullable().default(null),
    });
export const CREATE_BUSINESS_SERVING_CONTAINER_SCHEMA =
    BUSINESS_SERVING_CONTAINER_SCHEMA.omit(['id']);
